import React from "react";
import { FaGlobe, FaLink } from "react-icons/fa";
import { FiToggleRight } from "react-icons/fi";

const CommunitySection1 = () => {
  return (
    <div className="w-full bg-gray-50 flex justify-center py-12 px-6">
      <div className="max-w-6xl w-full bg-gray-300/30 rounded-2xl p-10 flex flex-col md:flex-row items-center md:items-start gap-10 shadow-lg">

        <div className="flex-1">
          <span className="bg-black text-white text-xs font-bold px-3 py-1 rounded-md">
           PLATFORMUMUZU KEŞFEDİN
          </span>
          <h2 className="text-3xl md:text-4xl font-semibold mt-4">
            İkincieltelefon.com.tr
          </h2>
          <p className="text-gray-600 text-sm mt-3">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book.
          </p>
          <p className="text-black font-medium text-sm mt-4">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s,
          </p>
          <p className="text-gray-600 text-sm">
            It has survived not only five centuries, but also the leap into
            electronic typesetting, remaining essentially unchanged. It was
            popularised in the 1960s with the release of Letraset sheets
            containing Lorem Ipsum passages, and more recently with desktop
            publishing software like Aldus PageMaker including versions of Lorem
            Ipsum.
          </p>
        </div>

        <div className="w-full md:w-[400px] space-y-4">

          <div className="bg-white rounded-xl p-4 flex justify-between items-center shadow-md border ">

            <div className="w-[60%] bg-white  p- ">
              <img
                src="/sss.png"
                alt="Component UI"
                className="w-full "
              />

            </div>

            <div className="w-[38%] bg-black rounded-lg p-3 flex flex-col justify-center items-center shadow-lg">
              <div
                className="p-2 rounded-full border-[3px] border-transparent"
                style={{
                  background:
                    "linear-gradient(black, black) padding-box, linear-gradient(to right, #FF6A3D, #735DFF) border-box",
                }}
              >
                <FaGlobe className="text-white text-2xl" />
              </div>
              <p className="text-white text-xl font-bold mt-2">2,316</p>
              <p className="text-gray-400 text-xs">Metin</p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-4 flex flex-col gap-3 shadow-md border border-gray-300">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2">
                <FaGlobe className="text-gray-500" />
                <p className="text-sm font-medium">Metin</p>
              </div>
              <FiToggleRight className="text-black text-2xl" />
            </div>
            <p className="text-xs text-gray-500">
              Metin
            </p>

            <div className="flex items-center justify-between bg-gray-100 p-2 rounded-lg border border-gray-300">
              <p className="text-xs text-gray-500 truncate">
                https://ikincieltelefon.com.tr/kategoriler/telefon
              </p>
              <button className="bg-gray-900 text-white text-xs font-semibold px-3 py-1 rounded-md flex items-center gap-2">
                <FaLink />
                Linki Kopyala
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunitySection1;
